import {FC} from 'react'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import styles from '../../styles.module.css'

type Props = {
  icon: string
  title: string
  text?: string
}

const EmptyState: FC<Props> = ({icon, title, text}) => (
  <div className={styles.empty}>
    <KTSVG path={icon} className='svg-icon-3x svg-icon-muted' />
    <span className={styles.emptyTitle}>{title}</span>
    {text && <span className={styles.emptyText}>{text}</span>}
  </div>
)

export {EmptyState}
